module.exports = __webpack_public_path__ + "img/apple.5894d4cd.png";